module.exports = __webpack_public_path__ + "img/servicioLegal.f1e5d703.jpg";